"use client";
import React, { useState } from "react";
import {
    Box,
    Grid,
    Typography,
    Button,
    ToggleButton,
    ToggleButtonGroup,
    Card,
    CardContent,
    Divider,
    Breadcrumbs,
    Link,
} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import { MostPopularIcon } from "../../icons";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
const planData = {
    annual: [
        {
            title: "Free",
            subtitle: "Best for personal use",
            price: "$0",
            condition: "/For one seat only",
            button: "Get started",
            featureHeading: 'What you get:',
            features: [
                "Time tracking",
                "Timesheets",
                "Activity levels",
                "Clients & Invoices",
                "Limited screenshots",
                "Limited reports",
                "Limited payments",
                "Limited support SLA",
            ],
        },
        {
            title: "Starter",
            subtitle: "2 seat minimum",
            price: "$40",
            condition: "/seat /year",
            button: "Get started",
            featureHeading: 'All free features, plus:',
            features: [
                "Time tracking",
                "Timesheets",
                "Activity levels",
                "Limited screenshots",
                "Limited app & URL tracking",
                "Limited reports",
                "Limited payments",
                "Clients & Invoices",
            ],
        },
        {
            title: "Team",
            subtitle: "2 seat minimum",
            price: "$100",
            condition: "/seat /year",
            button: "Get started",
            featureHeading: 'All starter features, plus:',
            popular: true,
            features: [
                "Unlimited screenshots",
                "Unlimited app & URL tracking",
                "Auto discard idle time",
                "Teams",
                "Payments & payroll",
                "Unlimited integrations",
                "Overtime",
                "Time off & holidays",
            ],
        },
        {
            title: "Enterprise",
            subtitle: "Billed annually",
            price: "Custom",
            button: "Get started",
            featureHeading: 'All business features, plus:',
            features: [
                "Higher limits on public API",
                "Pay by bank debit (ACH)",
                "HIPAA compliance",
                "SOC-2 Type II compliance",
                "Enterprise deployment",
                "Account provisioning",
                "Single sign-on",
                "Hubstaff Corporate app",
            ],
        },
    ],
    quarterly: [
        {
            title: "Free",
            subtitle: "Best for personal use",
            price: "$0",
            condition: "/For one seat only",
            button: "Get started",
            featureHeading: 'What you get:',
            features: [
                "Time tracking",
                "Timesheets",
                "Activity levels",
                "Clients & Invoices",
                "Limited screenshots",
                "Limited reports",
                "Limited payments",
                "Limited support SLA",
            ],
        },
        {
            title: "Starter",
            subtitle: "2 seat minimum",
            price: "$12",
            condition: "/seat /quarter",
            button: "Get started",
            featureHeading: 'All free features, plus:',
            features: [
                "Time tracking",
                "Timesheets",
                "Activity levels",
                "Limited screenshots",
                "Limited app & URL tracking",
                "Limited reports",
                "Limited payments",
                "Clients & Invoices",
            ],
        },
        {
            title: "Team",
            subtitle: "2 seat minimum",
            price: "$30",
            condition: "/seat /quarter",
            button: "Get started",
            popular: true,
            featureHeading: 'All starter features, plus:',
            features: [
                "Unlimited screenshots",
                "Unlimited app & URL tracking",
                "Auto discard idle time",
                "Teams",
                "Payments & payroll",
                "Unlimited integrations",
                "Overtime",
                "Time off & holidays",
            ],
        },
        {
            title: "Enterprise",
            subtitle: "Billed quarterly",
            price: "Custom",
            button: "Get started",
            featureHeading: 'All business features, plus:',
            features: [
                "Higher limits on public API",
                "Pay by bank debit (ACH)",
                "HIPAA compliance",
                "SOC-2 Type II compliance",
                "Enterprise deployment",
                "Account provisioning",
                "Single sign-on",
                "Hubstaff Corporate app",
            ],
        },
    ],
    monthly: [
        {
            title: "Free",
            subtitle: "Best for personal use",
            price: "$0",
            condition: "/For one seat only",
            button: "Get started",
            featureHeading: 'What you get:',
            features: [
                "Time tracking",
                "Timesheets",
                "Activity levels",
                "Clients & Invoices",
                "Limited screenshots",
                "Limited reports",
                "Limited payments",
                "Limited support SLA",
            ],
        },
        {
            title: "Starter",
            subtitle: "2 seat minimum",
            price: "$4",
            condition: "/seat /month",
            button: "Get started",
            featureHeading: 'All free features, plus:',
            features: [
                "Time tracking",
                "Timesheets",
                "Activity levels",
                "Limited screenshots",
                "Limited app & URL tracking",
                "Limited reports",
                "Limited payments",
                "Clients & Invoices",
            ],
        },
        {
            title: "Team",
            subtitle: "2 seat minimum",
            price: "$10",
            condition: "/seat /month",
            button: "Get started",
            popular: true,
            featureHeading: 'All starter features, plus:',
            features: [
                "Unlimited screenshots",
                "Unlimited app & URL tracking",
                "Auto discard idle time",
                "Teams",
                "Payments & payroll",
                "Unlimited integrations",
                "Overtime",
                "Time off & holidays",
            ],
        },
        {
            title: "Enterprise",
            subtitle: "Billed monthly",
            price: "Custom",
            button: "Get started",
            featureHeading: 'All business features, plus:',
            features: [
                "Higher limits on public API",
                "Pay by bank debit (ACH)",
                "HIPAA compliance",
                "SOC-2 Type II compliance",
                "Enterprise deployment",
                "Account provisioning",
                "Single sign-on",
                "Hubstaff Corporate app",
            ],
        },
    ],
};

export default function PricingPlans() {
    const [billing, setBilling] = useState("annual");

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Link underline="hover" color="inherit" href="/" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#1A1F36' }}>
                    <ArrowBackIosIcon sx={{ fontSize: '16px', color: '#1760EC', }} /> Settings
                </Link>
                <Link
                    underline="hover"
                    color="inherit"
                    href="/BillingSettings"
                >
                    Billing
                </Link>
                <Typography sx={{ color: 'text.primary' }}>Information</Typography>
            </Breadcrumbs>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, }}>
                <Box className="card-body  bg-base border rounded-3 overflow-hidden h-100" sx={{ display: 'flex', alignItems: 'center', width: '100%', padding: '14px 16px' }}>
                    <Typography sx={{ fontSize: '19px', fontWeight: '700', color: '#1A1F36' }}>
                        Billing Settings
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'between',
                    alignItems: 'start',
                    gap: 2,
                    marginTop: '24px',
                }}
            >
                <Box className="card-body bg-base border rounded-3 overflow-hidden" sx={{ textAlign: "center", py: 3, px: 2, }}>
                    <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ fontSize: { xl: '33px !important', lg: '28px !important', md: '28px !important', sm: '23px !important', xs: '22px !important' } }}>
                        What you need to grow your team and business
                    </Typography>
                    <Box sx={{ borderBottom: '1px solid #ccc', mb: 3 }}>
                        {/* Toggle Buttons */}
                        <ToggleButtonGroup
                            value={billing}
                            exclusive
                            onChange={(e, val) => val && setBilling(val)}
                            sx={{
                                my: 3,
                                border: "none",
                                "& .MuiToggleButton-root": {
                                    border: "none", // remove default border
                                    borderRadius: "20px", // fully rounded look
                                    px: 3,
                                    py: 1,
                                    textTransform: "uppercase",
                                    fontWeight: 600,
                                    color: "#1A1A1A",
                                },
                                "& .Mui-selected": {
                                    backgroundColor: "#0076FE !important", // active bg
                                    color: "#fff !important", // text color on active
                                },
                            }}
                        >
                            <ToggleButton value="annual">ANNUAL</ToggleButton>
                            <ToggleButton value="quarterly">QUARTERLY</ToggleButton>
                            <ToggleButton value="monthly">MONTHLY</ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                    {/* Pricing Grid */}
                    <Box alignItems='end' sx={{
                        display: 'grid',
                        gridTemplateColumns: { xl: 'repeat(auto-fill, minmax(24%, 1fr))', lg: 'repeat(auto-fill, minmax(24%, 1fr))', md: 'repeat(auto-fill, minmax(24%, 1fr))', sm: 'repeat(auto-fill, minmax(49%, 1fr))', xs: 'repeat(auto-fill, minmax(100%, 1fr))' },
                        gap: '1%',
                        justifyContent: 'center',
                    }}>
                        {planData[billing].map((plan, index) => (
                            <Box key={index} >
                                <Card
                                    sx={{
                                        border:
                                            plan.popular ? "2px solid #0076FE" : "1px solid #e0e0e0",
                                        borderRadius: 3,
                                        boxShadow: plan.popular ? 4 : 1,
                                        position: "relative",
                                    }}
                                >
                                    {plan.popular && (
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: 0,
                                                left: "0",
                                                right: '0',
                                                background: 'linear-gradient(91deg, #00AAE7 4.5%, #5932EA 100%)',
                                                color: "#fff",
                                                px: 2,
                                                py: 0.5,
                                                borderRadius: "8px 8px 0 0",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                gap: 0.6,
                                            }}
                                        >
                                            Most Popular <MostPopularIcon />
                                        </Box>
                                    )}
                                    <CardContent sx={{ textAlign: "center", pt: plan.popular ? 5 : 3 }}>
                                        <Typography variant="h6" fontWeight="bold">
                                            {plan.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" mb={1}>
                                            {plan.subtitle}
                                        </Typography>
                                        <Typography fontWeight="bold" color="#0076FE" sx={{ fontSize: { xl: '22px', lg: '19px', md: '18px', sm: '18px', xs: '18px' }, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, }}>
                                            {plan.price}
                                            {plan.condition && (
                                                <Typography variant="caption" color="text.secondary">
                                                    {plan.condition}
                                                </Typography>
                                            )}
                                        </Typography>

                                        <Button
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 2, mb: 3, borderRadius: "8px", background: '#0076FE', }}
                                        >
                                            {plan.button}
                                        </Button>
                                        <Divider />
                                        {/* 👇 Feature Heading */}
                                        <Typography
                                            fontWeight="bold"
                                            sx={{ mt: 2, mb: 1, color: "#1A1F36", textAlign: 'left', fontSize: { xl: '16px', lg: '14px', md: '13px', sm: '15px', xs: '15px' } }}
                                        >
                                            {plan.featureHeading}
                                        </Typography>
                                        <Box textAlign="left" mt={1}>
                                            {plan.features.map((feature, i) => (
                                                <Typography
                                                    key={i}
                                                    variant="body2"
                                                    sx={{ mb: 1, display: "flex", alignItems: "center", fontSize: { xl: '14px', lg: '13px', md: '11px', sm: '14px', xs: '14px' } }}
                                                >
                                                    <CheckIcon sx={{ color: '#0076FE', fontSize: '18px' }} /> {feature}
                                                </Typography>
                                            ))}
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </>
    );
}
